import { useState } from 'react';

const useCustomHook = () => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [openedItem, setOpenedItem] = useState(-1);
  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState(['sol']);
  const [isloadProgress, setIsLoadProgress] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);
  const [selectedIds, setSelectedIds] = useState([])
  const [demoLeftList, setDemoLeftList] = useState([]);
  const [expandPageIds, setExpandPageIds] = useState([]);
  const [selectedPageIds, setSelectedPageIds] = useState([]);
  const [buttonVisible, setButtonVisible] = useState(false);
  const [actionTree, setActionTree] = useState(null);
  const [copyActionTree, setCopyActionTree] = useState([]);
  const [selectedActionIds, setSelectedActionIds] = useState([]);
  const [rigthTreeHasChildren, setRightTreeHasChildren] = useState([]);
  const [treeRloading, setTreeRloading] = useState(false);
  const [allExpandIds, setAllExpandIds] = useState([]);
  const [expandIds, setExpandIds] = useState([])
  const [isDisabledTree, setIsDisabledTree] = useState(false);

  return {
    buttonVisible, setButtonVisible,
    submitLoading, setSubmitLoading,
    openedItem, setOpenedItem,
    checked, setChecked,
    expanded, setExpanded,
    isloadProgress, setIsLoadProgress,
    isDisabledTree, setIsDisabledTree,
    isLoading, setIsLoading,
    selectedIds, setSelectedIds,
    data, setData,
    demoLeftList, setDemoLeftList,
    expandPageIds, setExpandPageIds,
    actionTree, setActionTree,
    copyActionTree, setCopyActionTree,
    selectedActionIds, setSelectedActionIds,
    rigthTreeHasChildren, setRightTreeHasChildren,
    selectedPageIds, setSelectedPageIds,
    treeRloading, setTreeRloading,
    allExpandIds, setAllExpandIds,
    expandIds, setExpandIds
  };
};

export default useCustomHook;